import { render } from "./EmployeesWorkday.vue?vue&type=template&id=7eb5a518"
import script from "./EmployeesWorkday.vue?vue&type=script&lang=js"
export * from "./EmployeesWorkday.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\abbas\\Desktop\\kswc\\kswc_dashboard-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__